const LOAD_MORE_SELECTOR = "#load-more-btn";
const LOAD_MORE_DEFAULT_LABEL = "View more";

const resetLoadMoreButton = (button, label = LOAD_MORE_DEFAULT_LABEL) => {
  button.disabled = false;
  button.removeAttribute("aria-busy");
  button.textContent = label;
};

document.addEventListener("click", function (event) {
  const button = event.target.closest(LOAD_MORE_SELECTOR);
  if (!button) return;

  event.preventDefault();

  const nextPageUrl = button.dataset.nextPage;
  if (!nextPageUrl || button.disabled) return;

  const buttonLabel = button.dataset.originalLabel || button.textContent.trim() || LOAD_MORE_DEFAULT_LABEL;
  button.dataset.originalLabel = buttonLabel;

  button.disabled = true;
  button.setAttribute("aria-busy", "true");
  button.textContent = "Loading...";

  fetch(nextPageUrl)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const currentGrid = document.querySelector(".product-grid-container .product-grid");
      const newItems = doc.querySelectorAll(".product-grid-container .product-grid .grid__item");

      if (!currentGrid || !newItems.length) {
        resetLoadMoreButton(button, buttonLabel);
        return;
      }

      newItems.forEach((item) => currentGrid.appendChild(item));

      // Update or remove Load More button
      const newBtn = doc.getElementById("load-more-btn");
      if (newBtn && newBtn.dataset.nextPage) {
        button.dataset.nextPage = newBtn.dataset.nextPage;
        resetLoadMoreButton(button, buttonLabel);
      } else {
        button.remove();
      }
    })
    .catch((err) => {
      console.error("VIEW MORE failed:", err);
      button.textContent = "Error loading products";
      button.disabled = false;
      button.removeAttribute("aria-busy");
    });
});

let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector("header");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");

  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open");
    }, 500);

    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

document.querySelectorAll('.has-mega-menu').forEach(function (item) {
  item.addEventListener('mouseenter', function () {
    document.querySelector('.header-wrapper').classList.add('header--with-bg');
  });
  // item.addEventListener('mouseleave', function () {
  //   document.querySelector('.header-wrapper').classList.remove('header--with-bg');
  // });
});

let header_wrapper = document.querySelector('.header-wrapper');
header_wrapper.addEventListener('mouseenter', function () {
  document.querySelector('.header-wrapper').classList.add('header--with-bg');
});
header_wrapper.addEventListener('mouseleave', function () {
  document.querySelector('.header-wrapper').classList.remove('header--with-bg');
});


document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion details');

    accordions.forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (accordion.open) {
          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.removeAttribute('open');
            }
          });
        }
      });
    });
  });
